import { forwardRef, ReactNode } from "react";

import { cn } from "@/lib/utils";

export const StickyTable = forwardRef<
  HTMLDivElement,
  {
    children: ReactNode;
    footer?: ReactNode;
    hasRows: boolean;
  }
>(({ children, footer, hasRows }, ref) => (
  // relative is needed to prevent full-page scroll when an absolute positioned <select> component (radix ui default) is initially rendered off-screen
  <div ref={ref} className="relative overflow-hidden rounded-lg border">
    {/* Using table instead of shadcn's Table component because shadcn wraps table in a div with overflow-auto, preventing sticky header from working because the max-height is not attached to the overflow-auto. */}
    <div className="max-h-[70vh] overflow-auto overscroll-contain">
      <table
        className={cn(
          "column-borders w-full text-sm",
          hasRows && "min-w-max",
        )}
      >
        {children}
      </table>
    </div>
    {footer && (
      <div className="sticky bottom-0 border-t border-slate-200 bg-slate-50">
        {footer}
      </div>
    )}
  </div>
));

StickyTable.displayName = "StickyTable";
